import React, { useRef } from 'react';
import ScrollReveal, { RevealUp } from './ScrollReveal';

const TeamSection = () => {
  const scrollContainerRef = useRef(null);

  // Team members data - Professional temple management team
  const teamMembers = [
    {
      id: 1,
      name: 'पंडित राम नारायण शर्मा',
      role: 'मुख्य पुजारी',
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=300&h=300&fit=crop&crop=face',
      description: '25 वर्षों का धार्मिक अनुभव',
      specialization: 'वैदिक कर्मकांड विशेषज्ञ'
    },
    {
      id: 2,
      name: 'श्री झगरु यादव जी ',
      role: 'मंदिर समिति अध्यक्ष',
      image: '/images/temple/583713105_1299011472269374_8699779899208949519_n.jpg',
      description: 'सामाजिक सेवा एवं मंदिर कल्याण',
      specialization: 'समुदायिक विकास'
    },
    {
      id: 3,
      name: 'श्री वृजमोहन यादव',
      role: 'मंदिर समिति कोषाध्यक्ष',
      image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=300&h=300&fit=crop&crop=face',
      description: 'प्रशासनिक कार्य एवं संगठन',
      specialization: 'कानूनी सलाहकार'
    },
    {
      id: 4,
      name: 'डॉ. अनिल कुमार मिश्रा',
      role: 'धार्मिक सलाहकार',
      image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=300&h=300&fit=crop&crop=face',
      description: 'संस्कृत एवं धर्मशास्त्र विद्वान',
      specialization: 'शास्त्रीय अनुसंधान'
    },
    {
      id: 5,
      name: 'श्री अमरेश यादव',
      role: 'कार्यक्रम संयोजक',
      image: '/images/temple/482252646_2202430896821267_199280652644056895_n.jpg',
      description: 'वित्तीय प्रबंधन एवं लेखा',
      specialization: 'कार्यक्रम विशेष'
    },
    {
      id: 6,
      name: 'श्रीमती प्रिया सिंह',
      role: 'सांस्कृतिक समन्वयक',
      image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=300&h=300&fit=crop&crop=face',
      description: 'त्योहार एवं कार्यक्रम संयोजन',
      specialization: 'मिथिला कला विशेषज्ञ'
    },
    {
      id: 7,
      name: 'श्री रमेश गिरी ',
      role: 'युवा समन्वयक',
      image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=300&h=300&fit=crop&crop=face',
      description: 'युवा गतिविधियां एवं शिक्षा',
      specialization: 'डिजिटल मीडिया'
    },
    {
      id: 8,
      name: 'श्री किशोरी शरण सियापयारे जी महाराज ',
      role: 'सुरक्षा प्रमुख',
      image: 'https://images.unsplash.com/photo-1566492031773-4f4e44671d66?w=300&h=300&fit=crop&crop=face',
      description: 'मंदिर सुरक्षा एवं व्यवस्था',
      specialization: 'सुरक्षा प्रबंधन'
    }
  ];

  const getScrollAmount = () => {
    const card = scrollContainerRef.current?.querySelector('.team-member-card');
    return card ? card.offsetWidth + 24 : 320;
  };

  const scrollLeft = () => {
    scrollContainerRef.current?.scrollBy({
      left: -getScrollAmount(),
      behavior: 'smooth'
    });
  };

  const scrollRight = () => {
    scrollContainerRef.current?.scrollBy({
      left: getScrollAmount(),
      behavior: 'smooth'
    });
  };

  return (
    <section className="py-10 sm:py-14 bg-gradient-to-br from-temple-bg-soft to-temple-bg">
      <div className="max-w-5xl mx-auto px-4 sm:px-5">
        <RevealUp className="text-center mb-8 sm:mb-10">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-temple-primary/10 rounded-full mb-6">
            <i className="fas fa-users text-2xl text-temple-primary"></i>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-temple-text mb-6">
            हमारे समर्पित सदस्य 
          </h2>
          <div className="w-20 h-1 bg-temple-primary mx-auto mb-6"></div>
          <p className="text-lg text-temple-text-muted max-w-3xl mx-auto leading-relaxed">
            फुलहर धाम के संचालन, विकास और सेवा में समर्पित भाव से कार्यरत हमारे अनुभवी सदस्यगण
          </p>
        </RevealUp>

        <ScrollReveal animation="up" delay={300}>
          <div className="relative">
            {/* Navigation Buttons - Hidden on mobile */}
            <button
              onClick={scrollLeft}
              className="hidden lg:flex absolute -left-6 top-1/2 transform -translate-y-1/2 z-10 w-14 h-14 bg-white rounded-full shadow-temple-lg items-center justify-center text-temple-primary hover:bg-temple-primary hover:text-white transition-all duration-300 border-2 border-temple-primary/20 hover:border-temple-primary group"
              aria-label="Previous team members"
            >
              <i className="fas fa-chevron-left text-lg group-hover:scale-110 transition-transform"></i>
            </button>
            
            <button
              onClick={scrollRight}
              className="hidden lg:flex absolute -right-6 top-1/2 transform -translate-y-1/2 z-10 w-14 h-14 bg-white rounded-full shadow-temple-lg items-center justify-center text-temple-primary hover:bg-temple-primary hover:text-white transition-all duration-300 border-2 border-temple-primary/20 hover:border-temple-primary group"
              aria-label="Next team members"
            >
              <i className="fas fa-chevron-right text-lg group-hover:scale-110 transition-transform"></i>
            </button>

            {/* Scrollable Container */}
            <div
              ref={scrollContainerRef}
              className="flex gap-6 overflow-x-auto scroll-smooth scrollbar-hide py-8 px-2"
              style={{
                scrollSnapType: 'x mandatory',
                WebkitOverflowScrolling: 'touch'
              }}
            >
              {teamMembers.map((member, index) => (
                <div
                  key={member.id}
                  className="team-member-card flex-shrink-0 w-80 h-96 bg-white rounded-3xl overflow-hidden shadow-temple hover:shadow-temple-lg transition-all duration-500 hover:-translate-y-2 border border-temple-primary/10 group relative"
                  style={{ scrollSnapAlign: 'start' }}
                >
                  {/* Full Background Image */}
                  <div className="relative w-full h-full">
                    <img
                      src={member.image}
                      alt={member.name}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                      loading="lazy"
                    />
                    
                    {/* Gradient Overlay */}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
                    
                    {/* Verification Badge */}
                    <div className="absolute top-4 right-4 w-10 h-10 bg-temple-primary rounded-full flex items-center justify-center shadow-lg">
                      <i className="fas fa-check text-white text-sm"></i>
                    </div>

                    {/* Role Badge */}
                    <div className="absolute top-4 left-4">
                      <div className="bg-temple-primary/90 backdrop-blur-sm text-white px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide">
                        {member.role}
                      </div>
                    </div>

                    {/* Member Details - Bottom Overlay */}
                    <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                      <h3 className="text-xl font-bold font-serif mb-2 leading-tight">
                        {member.name}
                      </h3>
                      
                      <p className="text-white/90 text-sm mb-3 leading-relaxed">
                        {member.description}
                      </p>
                      
                      <div className="bg-white/20 backdrop-blur-sm rounded-lg p-3 mb-4">
                        <p className="text-temple-secondary font-semibold text-xs uppercase tracking-wide mb-1">
                          विशेषज्ञता
                        </p>
                        <p className="text-white text-sm font-medium">
                          {member.specialization}
                        </p>
                      </div>
                      
                      {/* Contact Button */}
                      <button className="w-full bg-white/20 backdrop-blur-sm hover:bg-white/30 text-white border border-white/30 px-4 py-2 rounded-xl text-sm font-bold transition-all duration-300 flex items-center justify-center group-hover:scale-105">
                        <i className="fas fa-phone mr-2"></i>
                        संपर्क करें
                      </button>
                    </div>

                    {/* Hover Effect Overlay */}
                    <div className="absolute inset-0 bg-temple-primary/0 group-hover:bg-temple-primary/10 transition-colors duration-300"></div>
                  </div>
                </div>
              ))}
            </div>

            {/* Mobile scroll indicator */}
            <div className="flex justify-center mt-6 lg:hidden">
              <div className="bg-temple-bg-warm rounded-full px-4 py-2 flex items-center space-x-2">
                <i className="fas fa-hand-point-right text-temple-primary"></i>
                <p className="text-temple-text-muted text-sm font-medium">
                  स्वाइप करके अधिक सदस्य देखें
                </p>
              </div>
            </div>
          </div>
        </ScrollReveal>

        {/* Call to Action */}
        <RevealUp className="text-center mt-12" delay={600}>
          <div className="bg-gradient-to-r from-temple-primary/5 to-temple-secondary/5 rounded-3xl p-8 border border-temple-primary/10">
            <h3 className="text-xl font-serif font-bold text-temple-text mb-4">
              हमारी टीम से जुड़ें
            </h3>
            <p className="text-temple-text-muted mb-6 max-w-2xl mx-auto">
              यदि आप भी फुलहर धाम की सेवा में योगदान देना चाहते हैं, तो हमसे संपर्क करें
            </p>
            <button className="bg-temple-primary text-white px-8 py-3 rounded-xl font-bold hover:bg-temple-primary-dark transition-colors duration-200 inline-flex items-center">
              <i className="fas fa-hands-helping mr-2"></i>
              स्वयंसेवक बनें
            </button>
          </div>
        </RevealUp>
      </div>
    </section>
  );
};

export default TeamSection;